export default __webpack_public_path__ + "static/media/center-call.aefe0204.svg";